<template>
  <div class="content-wrapper">
    <b-row class="main-content">
      <img :src="require('@/assets/image/github.png')" />
      <b-button @click="gotoAuth">
        Sign in with Github
      </b-button>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Login",
  computed: {
    ...mapGetters("user", ["isLoggedIn"])
  },
  methods: {
    gotoAuth() {
      window.location.href = "/api/github/auth";
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push({ path: "/home" });
    }
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);

  img {
    display: block;
    width: 100px;
    height: 100px;
    margin: 20px;
  }
}
</style>
